import { render } from "./app-icon-png.vue?vue&type=template&id=717bf638"
const script = {}

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/icon/app-icon-png.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "717bf638"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('717bf638', __exports__)) {
    console.log('reload')
    api.reload('717bf638', __exports__)
  }
  
  module.hot.accept("./app-icon-png.vue?vue&type=template&id=717bf638", () => {
    console.log('re-render')
    api.rerender('717bf638', render)
  })

}


export default __exports__